/**
 * Client for Voluum tracker POST /entity (proxied via TrafficPulse API).
 * For Media Devoted | Created By Ciro Autiero
 */

import api from '@/services/api';

export interface VoluumTrackerEntityQueryPayload {
  type: 'LANDER' | 'OFFER';
  id: string;
  dependencyQueries?: Array<{ type: string; fields: string[] }>;
}

export async function queryVoluumTrackerEntity(
  payload: VoluumTrackerEntityQueryPayload,
): Promise<unknown> {
  const { data } = await api.post<unknown>('/voluum/entity/query', payload);
  if (data !== null && typeof data === 'object' && 'data' in data) {
    return (data as { data: unknown }).data;
  }
  return data;
}
